import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseArticles } from "./UseArticles";
import { useSnackbar } from "notistack";

export default function ArticleresourcesGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { AddArticleResource, DeleteArticleResource } = UseArticles();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [state, setState] = useState({
    id: 0,
    articleID: "",
    resource: "",
    resourceURL: "",
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "resource",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "resource",
      width: 250,
      align: "center",
      headerName: "منبع",
      headerAlign: "center",
    },
    {
      field: "resourceURL",
      headerName: "آدرس",
      width: 350,
      align: "right",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.resourceURL
              ? cellValues.row.resourceURL
              : "بدون آدرس"}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 180,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.resource,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setState({
                    id: cellValues.row.id,
                    resource: cellValues.row.resource,
                    resourceURL: cellValues.row.resourceURL,
                    articleID: props.articleID,
                  });
                  setOpenDialog(true);
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            articleID: props.articleID,
            id: 0,
            resource: "",
            resourceURL: "",
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <TextField
              fullWidth
              value={state.resource ? state.resource : ""}
              label="منبع"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  articleID: props.articleID,
                  resource: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              fullWidth
              value={state.resourceURL ? state.resourceURL : ""}
              label="آدرس منبع"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  articleID: props.articleID,
                  resourceURL: evt.target.value,
                });
              }}
              multiline
              rows={4}
              sx={{ textarea: { direction: "rtl" }, my: 3 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box>
              <Button
                onClick={() => {
                  if (
                    state.resource == "" ||
                    state.resource == undefined ||
                    state.resource == null
                  ) {
                    enqueueSnackbar("لطفا منبع مقاله را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    setProgress(true);
                    AddArticleResource(state, () => {
                      setState({
                        articleID: props.articleID,
                        id: 0,
                        resource: "",
                        resourceURL: "",
                      });
                      props.callback();
                      setOpenDialog(false);
                    });
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    articleID: props.articleID,
                    id: 0,
                    resource: "",
                    resourceURL: "",
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={props.rows ? props.rows : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.rows && props.rows.length ? props.rows.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: props.rows && props.rows.length ? props.rows.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"منبع"}
        callback={() => {
          setProgress(true);
          DeleteArticleResource(deleteState.id, () => {
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
